<template>
	<div class="body-container">
		<checkOutHeader></checkOutHeader>
		<div class="global-header-spacer"></div>
		<div class="site-main-container">
			<div class="flow-checkout-container page-single-checkout-container container">
				<div class="order-pay-wrapper">
					<img src="../../assets/images/pay_successed.png" class="success-img" />
					<div class="order-infos">
						<div class="order-label">
							{{$t('order.amount')}}
							<span v-if="lang == 'zh'">{{amount}} 美元</span>
							<span v-else>${{amount}}</span>
						</div>
					</div>
					<div style="display: flex;justify-content: center;">
						<button class="continue-shopping-btn site-btn-tertiary"
							@click="openPage('/')">{{$t('cart.continueshopping')}}</button>
					</div>
				</div>
			</div>
		</div>
		<footers></footers>
	</div>
</template>

<script>
	import checkOutHeader from '../../components/checkOutHeader.vue'
	import footers from '../../components/footers.vue'
	export default {
		components: {
			checkOutHeader,
			footers
		},
		data() {
			return {
				isMobile: false,
				amount: 0,
				orderData: {},
				lang:''
			}
		},
		created() {
			this.scrollToTop()
			this.lang = localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en';
		},
		mounted() {
			this.amount = this.$route.params.amount
			this.orderData = this.$route.params.orderData
		}
	}
</script>

<style scoped>
	.order-pay-wrapper {
		width: 100%;
		height: auto;
		overflow: hidden;
	}

	.success-img {
		display: block;
		width: 260px;
		height: 200px;
		margin: 40px auto 10px;
	}

	.order-infos {
		width: 100%;
		height: auto;
		overflow: hidden;
	}

	.order-label {
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 18px;
		color: #333;
		font-weight: 700;
	}

	.order-label span {
		font-size: 28px;
		color: #008338;
	}
	.continue-shopping-btn {
		width: 400px;
		background-color: #008338;
		color: #fff;
		margin-top: 30px;
	}
</style>
